import { ApollonConfFkCollection } from "@/models/ApollonConfFk";

const collection = new ApollonConfFkCollection()
export async function useApollonConfFk() {
    let models = collection.getModels();
    if (models.length === 0) {
        await collection.query()
        models = collection.getModels()
    }
    return models
}